import { useState } from "react"
import { ShowGenreButton } from "../components/showGenreButton"
import { ShowAnimeCard } from "../components/ShowAnimeButton"
import { getRecommandations } from "../api"
export function RecommandationsPage() {

    const genres = [
        {
            "id": 28,
            "name": "Action"
        },
        {
            "id": 12,
            "name": "Aventure"
        },
        {
            "id": 16,
            "name": "Animation"
        },
        {
            "id": 35,
            "name": "Comédie"
        },
        {
            "id": 80,
            "name": "Crime"
        },
        {
            "id": 99,
            "name": "Documentaire"
        },
        {
            "id": 18,
            "name": "Drame"
        },
        {
            "id": 10751,
            "name": "Familial"
        },
        {
            "id": 14,
            "name": "Fantastique"
        },
        {
            "id": 36,
            "name": "Histoire"
        },
        {
            "id": 27,
            "name": "Horreur"
        },
        {
            "id": 10402,
            "name": "Musique"
        },
        {
            "id": 9648,
            "name": "Mystère"
        },
        {
            "id": 10749,
            "name": "Romance"
        },
        {
            "id": 878,
            "name": "Science-Fiction"
        },
        {
            "id": 10770,
            "name": "Téléfilm"
        },
        {
            "id": 53,
            "name": "Thriller"
        },
        {
            "id": 10752,
            "name": "Guerre"
        },
        {
            "id": 37,
            "name": "Western"
        }
    ]

    const [animesRecommandated, setAnimesRecommandated] = useState([])
    const [genresSelected, setGenresSelected] = useState([])
    const [loading, setLoading] = useState(false)

    async function handleGenerate() {
        setLoading(true)
        if (loading) return;
        const data = await getRecommandations(genresSelected)
        // console.log(11, data)
        setLoading(false)

        return setAnimesRecommandated(data)
    }

    return (
        <div class="text-white">
            <h1 className="text-3xl text-center font-semibold mb-4 mt-10">Page de Recommandation de FILMS</h1>
            {/* <hr className="mx-5" /> */}
            <h3 className="text-center my-2">Nous pouvons vous recommander des films a partir des genres suivants</h3>


            <div className="mt-10 w-full justify-center items-center flex flex-wrap flex-row gap-4">
                {genres.map(g => {
                    return (
                        ShowGenreButton(g, genresSelected, setGenresSelected)
                    )
                })}
            </div>
            <div className="mt-10 flex justify-center">
                <button onClick={() => handleGenerate()} className="py-2 px-10 bg-orange-500 rounded-lg">{loading ? "Chargement..." : "Générer"}</button>
            </div>

            <div className="mt-10 flex flex-wrap flex-row gap-8 justify-center">
                {animesRecommandated.length > 0 ?
                    <>
                        {animesRecommandated.map((anime, i) => {
                            console.log(anime[1][0])
                            return (
                                ShowAnimeCard(anime[1][0], i)
                            )
                        })}
                    </>
                    : null
                }
            </div>
        </div>
    )


}